import { render, staticRenderFns } from "./InnerList.vue?vue&type=template&id=488ef85f&scoped=true&"
import script from "./InnerList.vue?vue&type=script&lang=js&"
export * from "./InnerList.vue?vue&type=script&lang=js&"
import style0 from "./InnerList.vue?vue&type=style&index=0&id=488ef85f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488ef85f",
  null
  
)

export default component.exports